import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from "@chakra-ui/react"
import { useRef } from "react"

export default function AlertMessage({ isOpen, onClose, text, message, method, AffirmativeButtonText, AffirmativeButtonColor, CancelButtonText, CancelButtonColor }) {
    const cancelRef = useRef()
    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            closeOnOverlayClick={false}
            isCentered
        >

            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {text}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        {message}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        {
                            AffirmativeButtonText && AffirmativeButtonText.length > 0 &&
                            <Button
                                onClick={() => method ? method() : onClose()}
                                bg = {AffirmativeButtonColor ? AffirmativeButtonColor : 'green'}
                                color = 'white'
                            >
                                {AffirmativeButtonText}
                            </Button>
                        }
                        {
                            CancelButtonText && CancelButtonText.length > 0 &&
                            <Button
                                ref={cancelRef}
                                onClick={onClose}
                                bg = {CancelButtonColor ? CancelButtonColor : 'green'}
                                color = 'white'
                                ml = '1rem'
                            >
                                {CancelButtonText}
                            </Button>
                        }
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}